import * as types from '../types/supportTypes';

const initialState = {
  tickets: [],
  ticket: null,
  articles: [],
  article: null,
  forumCategories: [],
  forumPosts: [],
  forumPost: null,
  loading: false,
  error: null,
};

function supportReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_TICKETS_REQUEST:
    case types.FETCH_TICKET_BY_ID_REQUEST:
    case types.CREATE_TICKET_REQUEST:
    case types.UPDATE_TICKET_REQUEST:
    case types.FETCH_ARTICLES_REQUEST:
    case types.FETCH_ARTICLE_BY_ID_REQUEST:
    case types.FETCH_FORUM_CATEGORIES_REQUEST:
    case types.FETCH_FORUM_POSTS_REQUEST:
    case types.FETCH_FORUM_POST_BY_ID_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_TICKETS_SUCCESS:
      return { ...state, loading: false, tickets: action.payload };
    case types.FETCH_TICKET_BY_ID_SUCCESS:
      return { ...state, loading: false, ticket: action.payload };
    case types.FETCH_ARTICLES_SUCCESS:
      return { ...state, loading: false, articles: action.payload };
    case types.FETCH_ARTICLE_BY_ID_SUCCESS:
      return { ...state, loading: false, article: action.payload };
    case types.FETCH_FORUM_CATEGORIES_SUCCESS:
      return { ...state, loading: false, forumCategories: action.payload };
    case types.FETCH_FORUM_POSTS_SUCCESS:
      return { ...state, loading: false, forumPosts: action.payload };
    case types.FETCH_FORUM_POST_BY_ID_SUCCESS:
      return { ...state, loading: false, forumPost: action.payload };
    case types.CREATE_FORUM_POST_SUCCESS:
      return { ...state, loading: false, forumPosts: [action.payload, ...state.forumPosts] };
    case types.CREATE_FORUM_REPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        forumPost: state.forumPost
          ? { ...state.forumPost, replies: [...(state.forumPost.replies || []), action.payload] }
          : null,
      };
    case types.CREATE_TICKET_SUCCESS:
      return { ...state, loading: false, tickets: [...state.tickets, action.payload] };
    case types.UPDATE_TICKET_SUCCESS: {
      const updated = action.payload;
      return {
        ...state,
        loading: false,
        tickets: state.tickets.map((t) => (t._id === updated._id ? updated : t)),
        ticket: state.ticket && state.ticket._id === updated._id ? updated : state.ticket,
      };
    }
    case types.FETCH_TICKETS_FAILURE:
    case types.FETCH_TICKET_BY_ID_FAILURE:
    case types.CREATE_TICKET_FAILURE:
    case types.UPDATE_TICKET_FAILURE:
    case types.FETCH_ARTICLES_FAILURE:
    case types.FETCH_ARTICLE_BY_ID_FAILURE:
    case types.FETCH_FORUM_CATEGORIES_FAILURE:
    case types.FETCH_FORUM_POSTS_FAILURE:
    case types.FETCH_FORUM_POST_BY_ID_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export default supportReducer;
